var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4238 3.93958C15.4838 3.61843 15.6542 3.32836 15.9055 3.11963C16.1569 2.91089 16.4733 2.79663 16.8 2.79663C17.1267 2.79663 17.4431 2.91089 17.6945 3.11963C17.9458 3.32836 18.1162 3.61843 18.1762 3.93958L19.6476 11.7208C19.7521 12.274 20.0209 12.7828 20.419 13.1809C20.8171 13.579 21.326 13.8479 21.8792 13.9524L29.6604 15.4238C29.9815 15.4838 30.2716 15.6542 30.4803 15.9055C30.6891 16.1569 30.8033 16.4733 30.8033 16.8C30.8033 17.1267 30.6891 17.4431 30.4803 17.6945C30.2716 17.9458 29.9815 18.1162 29.6604 18.1762L21.8792 19.6476C21.326 19.7521 20.8171 20.0209 20.419 20.419C20.0209 20.8171 19.7521 21.326 19.6476 21.8792L18.1762 29.6604C18.1162 29.9815 17.9458 30.2716 17.6945 30.4803C17.4431 30.6891 17.1267 30.8033 16.8 30.8033C16.4733 30.8033 16.1569 30.6891 15.9055 30.4803C15.6542 30.2716 15.4838 29.9815 15.4238 29.6604L13.9524 21.8792C13.8479 21.326 13.579 20.8171 13.1809 20.419C12.7828 20.0209 12.274 19.7521 11.7208 19.6476L3.93958 18.1762C3.61843 18.1162 3.32836 17.9458 3.11963 17.6945C2.91089 17.4431 2.79663 17.1267 2.79663 16.8C2.79663 16.4733 2.91089 16.1569 3.11963 15.9055C3.32836 15.6542 3.61843 15.4838 3.93958 15.4238L11.7208 13.9524C12.274 13.8479 12.7828 13.579 13.1809 13.1809C13.579 12.7828 13.8479 12.274 13.9524 11.7208L15.4238 3.93958Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2.80005V8.40005",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 5.6001H25.2",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60005 30.8C7.14645 30.8 8.40005 29.5463 8.40005 28C8.40005 26.4536 7.14645 25.2 5.60005 25.2C4.05365 25.2 2.80005 26.4536 2.80005 28C2.80005 29.5463 4.05365 30.8 5.60005 30.8Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSign);
export default __webpack_public_path__ + "static/media/star_sign.b54904833171dc58f23b376263ff103c.svg";
export { ForwardRef as ReactComponent };